"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleActivityIndicator = void 0;
const react_1 = __importDefault(require("react"));
const rn_css_1 = require("rn-css");
const react_native_1 = require("react-native");
const base_ui_all_1 = require("@unboared/base-ui.all");
const base_activity_indicator_1 = require("../base_activity_indicator");
const SimpleActivityIndicator = (props) => {
    const { style, textStyle, infos, color, size } = props, rest = __rest(props, ["style", "textStyle", "infos", "color", "size"]);
    const { normalize } = (0, base_ui_all_1.useNormalize)();
    const theme = (0, rn_css_1.useTheme)() || base_ui_all_1.unboaredTheme.default;
    let customSize;
    if (typeof size === 'string') {
        switch (size) {
            case 'small':
                customSize = normalize(20);
                break;
            default:
                customSize = normalize(40);
                break;
        }
    }
    else {
        customSize = normalize(size || 20);
    }
    return (react_1.default.createElement(base_activity_indicator_1.BaseActivityIndicator, { infos: infos, style: style, textStyle: textStyle },
        react_1.default.createElement(react_native_1.ActivityIndicator, Object.assign({}, rest, { color: color || theme.textColor, size: customSize }))));
};
exports.SimpleActivityIndicator = SimpleActivityIndicator;
//# sourceMappingURL=simple_activity_indicator.js.map